(function () {

    'use strict';

    if (typeof window === 'undefined') {

        module.exports = exportFn();

    } else {
        RivalIQ.module('metrics.new.enums', function (enums) {
            enums.ListeningGeos = exportFn();
        });

    }

    function exportFn() {
        return {
            Afghanistan: 'Afghanistan',
            Albania: 'Albania',
            Algeria: 'Algeria',
            Andorra: 'Andorra',
            Angola: 'Angola',
            'Antigua and Barbuda': 'Antigua and Barbuda',
            Argentina: 'Argentina',
            Armenia: 'Armenia',
            Australia: 'Australia',
            Austria: 'Austria',
            Azerbaijan: 'Azerbaijan',
            Bahamas: 'Bahamas',
            Bahrain: 'Bahrain',
            Bangladesh: 'Bangladesh',
            Barbados: 'Barbados',
            Belarus: 'Belarus',
            Belgium: 'Belgium',
            Belize: 'Belize',
            Benin: 'Benin',
            Bhutan: 'Bhutan',
            Bolivia: 'Bolivia',
            'Bosnia and Herzegovina': 'Bosnia and Herzegovina',
            Botswana: 'Botswana',
            Brazil: 'Brazil',
            Brunei: 'Brunei',
            Bulgaria: 'Bulgaria',
            'Burkina Faso': 'Burkina Faso',
            Burundi: 'Burundi',
            Cambodia: 'Cambodia',
            Cameroon: 'Cameroon',
            Canada: 'Canada',
            'Cape Verde': 'Cape Verde',
            'Central African Republic': 'Central African Republic',
            'Republic of Chad': 'Republic of Chad',
            Chile: 'Chile',
            China: 'China',
            Colombia: 'Colombia',
            Comoros: 'Comoros',
            'Costa Rica': 'Costa Rica',
            'Cote d\'Ivoire': 'Cote d\'Ivoire',
            Croatia: 'Croatia',
            Cuba: 'Cuba',
            Cyprus: 'Cyprus',
            'Czech Republic': 'Czech Republic',
            'Democratic Republic of the Congo': 'Democratic Republic of the Congo',
            Denmark: 'Denmark',
            Djibouti: 'Djibouti',
            Dominica: 'Dominica',
            'Dominican Republic': 'Dominican Republic',
            'East Timor': 'East Timor',
            Ecuador: 'Ecuador',
            Egypt: 'Egypt',
            'Equatorial Guinea': 'Equatorial Guinea',
            Eritrea: 'Eritrea',
            Estonia: 'Estonia',
            Ethiopia: 'Ethiopia',
            Fiji: 'Fiji',
            Finland: 'Finland',
            France: 'France',
            Gabon: 'Gabon',
            Gambia: 'Gambia',
            'Republic of Georgia': 'Republic of Georgia',
            Germany: 'Germany',
            Ghana: 'Ghana',
            Greece: 'Greece',
            Grenada: 'Grenada',
            Guatemala: 'Guatemala',
            Guinea: 'Guinea',
            'Guinea-Bissau': 'Guinea-Bissau',
            Guyana: 'Guyana',
            Haiti: 'Haiti',
            Honduras: 'Honduras',
            Hungary: 'Hungary',
            Iceland: 'Iceland',
            India: 'India',
            Indonesia: 'Indonesia',
            Iran: 'Iran',
            Iraq: 'Iraq',
            Ireland: 'Ireland',
            Israel: 'Israel',
            Italy: 'Italy',
            Jamaica: 'Jamaica',
            Japan: 'Japan',
            Jordan: 'Jordan',
            Kazakhstan: 'Kazakhstan',
            Kenya: 'Kenya',
            Kiribati: 'Kiribati',
            Kuwait: 'Kuwait',
            Kyrgyzstan: 'Kyrgyzstan',
            Laos: 'Laos',
            Latvia: 'Latvia',
            Lebanon: 'Lebanon',
            Lesotho: 'Lesotho',
            Liberia: 'Liberia',
            Libya: 'Libya',
            Liechtenstein: 'Liechtenstein',
            Lithuania: 'Lithuania',
            Luxembourg: 'Luxembourg',
            'Republic of Macedonia': 'Republic of Macedonia',
            Madagascar: 'Madagascar',
            Malawi: 'Malawi',
            Malaysia: 'Malaysia',
            Maldives: 'Maldives',
            Mali: 'Mali',
            Malta: 'Malta',
            'Marshall Islands': 'Marshall Islands',
            Mauritania: 'Mauritania',
            Mauritius: 'Mauritius',
            Mexico: 'Mexico',
            'Federated States of Micronesia': 'Federated States of Micronesia',
            Moldova: 'Moldova',
            Monaco: 'Monaco',
            Mongolia: 'Mongolia',
            Montenegro: 'Montenegro',
            Morocco: 'Morocco',
            Mozambique: 'Mozambique',
            Myanmar: 'Myanmar',
            Namibia: 'Namibia',
            Nauru: 'Nauru',
            Nepal: 'Nepal',
            Netherlands: 'Netherlands',
            'New Zealand': 'New Zealand',
            Nicaragua: 'Nicaragua',
            Niger: 'Niger',
            Nigeria: 'Nigeria',
            'North Korea': 'North Korea',
            Norway: 'Norway',
            Oman: 'Oman',
            Pakistan: 'Pakistan',
            Palau: 'Palau',
            Panama: 'Panama',
            'Papua New Guinea': 'Papua New Guinea',
            Paraguay: 'Paraguay',
            Peru: 'Peru',
            Philippines: 'Philippines',
            Poland: 'Poland',
            Portugal: 'Portugal',
            Qatar: 'Qatar',
            'Republic of the Congo': 'Republic of the Congo',
            Romania: 'Romania',
            Russia: 'Russia',
            Rwanda: 'Rwanda',
            'Saint Kitts and Nevis': 'Saint Kitts and Nevis',
            'Saint Lucia': 'Saint Lucia',
            'Saint Vincent and the Grenadines': 'Saint Vincent and the Grenadines',
            Samoa: 'Samoa',
            'San Marino': 'San Marino',
            'Sao Tome and Principe': 'Sao Tome and Principe',
            'Saudi Arabia': 'Saudi Arabia',
            Senegal: 'Senegal',
            Serbia: 'Serbia',
            Seychelles: 'Seychelles',
            'Sierra Leone': 'Sierra Leone',
            Singapore: 'Singapore',
            Slovakia: 'Slovakia',
            Slovenia: 'Slovenia',
            'Solomon Islands': 'Solomon Islands',
            Somalia: 'Somalia',
            'South Africa': 'South Africa',
            'South Korea': 'South Korea',
            Spain: 'Spain',
            'Sri Lanka': 'Sri Lanka',
            Sudan: 'Sudan',
            Suriname: 'Suriname',
            Swaziland: 'Swaziland',
            Sweden: 'Sweden',
            Switzerland: 'Switzerland',
            Syria: 'Syria',
            Tajikistan: 'Tajikistan',
            Tanzania: 'Tanzania',
            Thailand: 'Thailand',
            Togo: 'Togo',
            Tonga: 'Tonga',
            'Trinidad and Tobago': 'Trinidad and Tobago',
            Tunisia: 'Tunisia',
            Turkey: 'Turkey',
            Turkmenistan: 'Turkmenistan',
            Tuvalu: 'Tuvalu',
            Uganda: 'Uganda',
            Ukraine: 'Ukraine',
            'United Arab Emirates': 'United Arab Emirates',
            'United Kingdom': 'United Kingdom',
            'United States': 'United States',
            Uruguay: 'Uruguay',
            Uzbekistan: 'Uzbekistan',
            Vanuatu: 'Vanuatu',
            Venezuela: 'Venezuela',
            Vietnam: 'Vietnam',
            Yemen: 'Yemen',
            Zambia: 'Zambia',
            Zimbabwe: 'Zimbabwe',
            Taiwan: 'Taiwan',
            Kosovo: 'Kosovo',
            'French Polynesia': 'French Polynesia',
            'Palestinian territories': 'Palestinian territories'

            /* only include countries for now, see #34392

            Alabama: 'Alabama',
            Alaska: 'Alaska',
            Arizona: 'Arizona',
            Arkansas: 'Arkansas',
            California: 'California',
            Colorado: 'Colorado',
            Connecticut: 'Connecticut',
            Delaware: 'Delaware',
            Florida: 'Florida',
            Georgia: 'Georgia',
            Hawaii: 'Hawaii',
            Idaho: 'Idaho',
            Illinois: 'Illinois',
            Indiana: 'Indiana',
            Iowa: 'Iowa',
            Kansas: 'Kansas',
            Kentucky: 'Kentucky',
            Louisiana: 'Louisiana',
            Maine: 'Maine',
            Maryland: 'Maryland',
            Massachusetts: 'Massachusetts',
            Michigan: 'Michigan',
            Minnesota: 'Minnesota',
            Mississippi: 'Mississippi',
            Missouri: 'Missouri',
            Montana: 'Montana',
            Nebraska: 'Nebraska',
            Nevada: 'Nevada',
            'New Hampshire': 'New Hampshire',
            'New Jersey': 'New Jersey',
            'New Mexico': 'New Mexico',
            'New York': 'New York',
            'North Carolina': 'North Carolina',
            'North Dakota': 'North Dakota',
            Ohio: 'Ohio',
            Oklahoma: 'Oklahoma',
            Oregon: 'Oregon',
            Pennsylvania: 'Pennsylvania',
            'Rhode Island': 'Rhode Island',
            'South Carolina': 'South Carolina',
            'South Dakota': 'South Dakota',
            Tennessee: 'Tennessee',
            Texas: 'Texas',
            Utah: 'Utah',
            Vermont: 'Vermont',
            Virginia: 'Virginia',
            Washington: 'Washington',
            'West Virginia': 'West Virginia',
            Wisconsin: 'Wisconsin',
            Wyoming: 'Wyoming',
            'District of Columbia': 'District of Columbia',
            Alberta: 'Alberta',
            Manitoba: 'Manitoba',
            'Newfoundland and Labrador': 'Newfoundland and Labrador',
            'Nova Scotia': 'Nova Scotia',
            Ontario: 'Ontario',
            Quebec: 'Quebec',
            'Yukon Territory': 'Yukon Territory',
            'British Columbia': 'British Columbia',
            'New Brunswick': 'New Brunswick',
            'Northwest Territories': 'Northwest Territories',
            Nunavut: 'Nunavut',
            'Prince Edward Island': 'Prince Edward Island',
            Saskatchewan: 'Saskatchewan',
            Africa: 'Africa',
            Asia: 'Asia',
            Americas: 'Americas',
            Europe: 'Europe',
            Oceania: 'Oceania',
            Antarctica: 'Antarctica',
            'Northern Africa': 'Northern Africa',
            'Western Africa': 'Western Africa',
            'Middle Africa': 'Middle Africa',
            'Eastern Africa': 'Eastern Africa',
            'Southern Africa': 'Southern Africa',
            'Northern Europe': 'Northern Europe',
            'Western Europe': 'Western Europe',
            'Eastern Europe': 'Eastern Europe',
            'Southern Europe': 'Southern Europe',
            'Northern America': 'Northern America',
            Caribbean: 'Caribbean',
            'Central America': 'Central America',
            'South America': 'South America',
            'Central Asia': 'Central Asia',
            'Eastern Asia': 'Eastern Asia',
            'Southern Asia': 'Southern Asia',
            'South-Eastern Asia': 'South-Eastern Asia',
            'Western Asia': 'Western Asia',
            'Australia and New Zealand': 'Australia and New Zealand',
            Melanesia: 'Melanesia',
            Micronesia: 'Micronesia',
            Polynesia: 'Polynesia'

            */
        };
    }
})();
